import MainLayout, { CenteredContent } from './MainLayout';
import RegistrationConfirmation from '../components/Register/RegistrationConfirmation';

const RegistrationConfirmationView = () => {
    return (
        <MainLayout>
            <CenteredContent>
                <RegistrationConfirmation />
            </CenteredContent>
        </MainLayout>
    );
};
export default RegistrationConfirmationView;
